import { render, staticRenderFns } from "./shortcutDialog.vue?vue&type=template&id=7a53fccc&"
import script from "./shortcutDialog.vue?vue&type=script&lang=js&"
export * from "./shortcutDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports